import { render, staticRenderFns } from "./ContactOrders.vue?vue&type=template&id=64411d6e&scoped=true&"
import script from "./ContactOrders.vue?vue&type=script&lang=js&"
export * from "./ContactOrders.vue?vue&type=script&lang=js&"
import style0 from "./ContactOrders.vue?vue&type=style&index=0&id=64411d6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64411d6e",
  null
  
)

export default component.exports